import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ExerciseContext } from "../context/ExerciseContext";
import "../styles/ExerciseSelector.css";

// Importy pro grafy (Recharts)
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

// Seznam cviků s dvěma verzemi videa
const exercises = [
{ name: "Angličák", cardio: 10, strength: 8, image: "/images/exercises_lowres/Jack-Burpee-360.mp4", videoTimer: "/images/exercises_hires/Jack-Burpee-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Klik s úzkým úchopem", cardio: 5, strength: 10, image: "/images/exercises_lowres/Close-Grip-Push-up_Upper-Arms-360.mp4", videoTimer: "/images/exercises_hires/Close-Grip-Push-up_Upper-Arms-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Široký klik", cardio: 4, strength: 8, image: "/images/exercises_lowres/Wide-Hand-Push-up-360.mp4", videoTimer: "/images/exercises_hires/Wide-Hand-Push-up-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Skakací panák", cardio: 7, strength: 1, image: "/images/exercises_lowres/Jumping-Jack-360.mp4", videoTimer: "/images/exercises_hires/Jumping-Jack-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Široký dřep s výskokem", cardio: 7, strength: 7, image: "/images/exercises_lowres/Wide-Stance-Jump-360.mp4", videoTimer: "/images/exercises_hires/Wide-Stance-Jump-720.mp4", bodyPart: "Dolní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Vysoká kolena - sprint", cardio: 8, strength: 3, image: "/images/exercises_lowres/High-Knee-Sprints-360.mp4", videoTimer: "/images/exercises_hires/High-Knee-Sprints-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Dynamické výpady", cardio: 8, strength: 6, image: "/images/exercises_lowres/Cardio-Lunge-360.mp4", videoTimer: "/images/exercises_hires/Cardio-Lunge-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Sedy-lehy", cardio: 3, strength: 7, image: "/images/exercises_lowres/Sit-up-360.mp4", videoTimer: "/images/exercises_hires/Sit-up-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Dřep s výskokem", cardio: 6, strength: 7, image: "/images/exercises_lowres/Air-Squat-360.mp4", videoTimer: "/images/exercises_hires/Air-Squat-720.mp4", bodyPart: "Dolní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Střídavé údery", cardio: 4, strength: 2, image: "/images/exercises_lowres/Alternate-Punching-360.mp4", videoTimer: "/images/exercises_hires/Alternate-Punching-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Sklapovačky", cardio: 5, strength: 9, image: "/images/exercises_lowres/Jack-Split-Crunches-360.mp4", videoTimer: "/images/exercises_hires/Jack-Split-Crunches-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Vysoká kolena - chůze", cardio: 6, strength: 2, image: "/images/exercises_lowres/Walk-360.mp4", videoTimer: "/images/exercises_hires/Walk-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Zkracovačky", cardio: 2, strength: 7, image: "/images/exercises_lowres/90-Degree-Heel-Touch-360.mp4", videoTimer: "/images/exercises_hires/90-Degree-Heel-Touch-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Zakopávání", cardio: 5, strength: 1, image: "/images/exercises_lowres/Butt-Kicks-360.mp4", videoTimer: "/images/exercises_hires/Butt-Kicks-720.mp4", bodyPart: "Dolní část těla", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Střídavé zkracovačky", cardio: 3, strength: 7, image: "/images/exercises_lowres/Alternate-Heel-Touchers-360.mp4", videoTimer: "/images/exercises_hires/Alternate-Heel-Touchers-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Dlouhý nízký výpad", cardio: 4, strength: 6, image: "/images/exercises_lowres/Long-Distance-Lunge-360.mp4", videoTimer: "/images/exercises_hires/Long-Distance-Lunge-720.mp4", bodyPart: "Dolní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Superman", cardio: 1, strength: 3, image: "/images/exercises_lowres/Superman-360.mp4", videoTimer: "/images/exercises_hires/Superman-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Horolezec", cardio: 8, strength: 6, image: "/images/exercises_lowres/Mountain-Climber-360.mp4", videoTimer: "/images/exercises_hires/Mountain-Climber-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Výpad", cardio: 2, strength: 5, image: "/images/exercises_lowres/Split-Squats-360.mp4", videoTimer: "/images/exercises_hires/Split-Squats-720.mp4", bodyPart: "Dolní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Bruslařské skoky", cardio: 8, strength: 5, image: "/images/exercises_lowres/Skater-Hops-360.mp4", videoTimer: "/images/exercises_hires/Skater-Hops-720.mp4", bodyPart: "Dolní část těla", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Kliky na kolenou", cardio: 3, strength: 6, image: "/images/exercises_lowres/Push-up-on-knees-360.mp4", videoTimer: "/images/exercises_hires/Push-up-on-knees-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Šlapání ve vzduchu", cardio: 7, strength: 5, image: "/images/exercises_lowres/Bicycle-Crunch-360.mp4", videoTimer: "/images/exercises_hires/Bicycle-Crunch-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Šikmé přítahy ve stoje", cardio: 4, strength: 5, image: "/images/exercises_lowres/Cross-Standing-Crunch-360.mp4", videoTimer: "/images/exercises_hires/Cross-Standing-Crunch-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Medvědí chůze", cardio: 4, strength: 7, image: "/images/exercises_lowres/Bear-Crawl-low-hip-360.mp4", videoTimer: "/images/exercises_hires/Bear-Crawl-low-hip-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Plank s natažením ruky a nohy", cardio: 2, strength: 6, image: "/images/exercises_lowres/Bird-Dog-Plank-360.mp4", videoTimer: "/images/exercises_hires/Bird-Dog-Plank-720.mp4", bodyPart: "Celé tělo", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Izometrický klik", cardio: 1, strength: 7, image: "/images/exercises_lowres/Isometric-Hold-Push-up-360.mp4", videoTimer: "/images/exercises_hires/Isometric-Hold-Push-up-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Cyklistické sklapovačky", cardio: 4, strength: 7, image: "/images/exercises_lowres/Air-bike-360.mp4", videoTimer: "/images/exercises_hires/Air-bike-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Cyklistické sklapovačky, v2", cardio: 4, strength: 8, image: "/images/exercises_lowres/Air-Bike-v2-360.mp4", videoTimer: "/images/exercises_hires/Air-Bike-v2-720.mp4", bodyPart: "Střed těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Kliky na prstech", cardio: 4, strength: 10, image: "/images/exercises_lowres/Finger-Push-up-360.mp4", videoTimer: "/images/exercises_hires/Finger-Push-up-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Kliky na kloubech", cardio: 4, strength: 9, image: "/images/exercises_lowres/Knuckle-Push-Up-360.mp4", videoTimer: "/images/exercises_hires/Knuckle-Push-Up-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Síla" },
{ name: "Klik s tlesknutím", cardio: 5, strength: 10, image: "/images/exercises_lowres/Clap-Push-Up-360.mp4", videoTimer: "/images/exercises_hires/Clap-Push-Up-720.mp4", bodyPart: "Horní část těla", equipment: "Váha těla", exerciseType: "Kardio" },
{ name: "Skákání přes švihadlo", cardio: 3, strength: 4, image: "/images/exercises_lowres/Jump-Rope-360.mp4", videoTimer: "/images/exercises_hires/Jump-Rope-720.mp4", bodyPart: "Dolní část těla", equipment: "Švihadlo", exerciseType: "Kardio" },
{ name: "Výskok na bednu", cardio: 3, strength: 4, image: "/images/exercises_lowres/Jump-Box-360.mp4", videoTimer: "/images/exercises_hires/Jump-Box-720.mp4", bodyPart: "Celé tělo", equipment: "Bedna", exerciseType: "Síla" },
{ name: "Vysoký kop", cardio: 9, strength: 8, image: "/images/exercises_lowres/Hook-Kick-Kickboxing-360.mp4", videoTimer: "/images/exercises_hires/Hook-Kick-Kickboxing-720.mp4", bodyPart: "Celé tělo", equipment: "Pytel", exerciseType: "Kardio" },
{ name: "Přední kop", cardio: 5, strength: 4, image: "/images/exercises_lowres/Front-Kick-Kickboxing-360.mp4", videoTimer: "/images/exercises_hires/Front-Kick-Kickboxing-720.mp4", bodyPart: "Dolní část těla", equipment: "Pytel", exerciseType: "Kardio" },


];

const ExerciseSelector = () => {
  const { selectedExercises, setSelectedExercises } = useContext(ExerciseContext);
  const navigate = useNavigate();

  // Aktualizace vybraného cviku
  const handleChange = (index, selectedOption) => {
    const updatedExercises = [...selectedExercises];
    updatedExercises[index] = selectedOption;
    setSelectedExercises(updatedExercises);
  };

  // Průměrné hodnoty pro grafy
  const averageCardio = selectedExercises.filter(Boolean).reduce((acc, exercise) => acc + exercise.cardio, 0) / selectedExercises.filter(Boolean).length;
  const averageStrength = selectedExercises.filter(Boolean).reduce((acc, exercise) => acc + exercise.strength, 0) / selectedExercises.filter(Boolean).length;

  const handleContinue = () => navigate("/ad"); // tlačítko pro pokračování

  // Data pro LineChart
  const graphData = selectedExercises.map(exercise => ({
    name: exercise ? exercise.name : '',
    strength: exercise ? exercise.strength : 0,
    cardio: exercise ? exercise.cardio : 0,
  }));

  const renderGraph = graphData.length > 0;

  // Data pro PieChart
  const pieChartDataCardio = [
    { name: 'Kardio', value: averageCardio },
    { name: 'Ostatní', value: 10 - averageCardio },
  ];

  const pieChartDataStrength = [
    { name: 'Síla', value: averageStrength },
    { name: 'Ostatní', value: 10 - averageStrength },
  ];

  return (
    <div className="exercise-selector-container">
      <img src="/images/background.jpg" alt="background" className="bg-video" />
      <div className="overlay"></div>

      <div className="logo-container">
        <a href="https://www.tabataworkout.cz">
          <img src="/images/logo.png" alt="Logo" className="logo" />
        </a>
      </div>

      <div>
        <h4>Vyber si 8 cviků</h4>
        <div className="selectors">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="selector">
              {/* React Select pro výběr cviku */}
              <Select
                options={exercises.map(ex => ({ value: ex.name, label: ex.name, ...ex }))}
                onChange={(selectedOption) => handleChange(index, selectedOption)}
                placeholder={`Cvik ${index + 1}`}
                isSearchable
                filterOption={(option, rawInput) => {
                  const input = rawInput.toLowerCase();
                  return (
                    option.data.name.toLowerCase().includes(input) ||
                    option.data.bodyPart.toLowerCase().includes(input) ||
                    option.data.equipment.toLowerCase().includes(input) ||
                    option.data.exerciseType.toLowerCase().includes(input)
                  );
                }}
                formatOptionLabel={(option) => (
                  <div>
                    <strong>{option.label}</strong>
                    <div style={{ fontSize: "0.8em", color: "#555" }}>
                      Kardio: {option.cardio} | Síla: {option.strength} | Část těla: {option.bodyPart} | Vybavení: {option.equipment} | Typ: {option.exerciseType}
                    </div>
                  </div>
                )}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />

              {/* Zobrazení videa miniatura */}
              {selectedExercises[index] && (
                <div>
                  <video
                    src={selectedExercises[index].image} // menší verze pro výběr
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="exercise-image"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {renderGraph && (
        <div style={{ marginTop: "10px" }}>
          <h4>Graf Síly a Kardia pro vybrané cviky</h4>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={graphData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fill: "1c192c" }} />
              <YAxis tick={{ fill: "1c192c" }} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="strength" stroke="#E51937" />
              <Line type="monotone" dataKey="cardio" stroke="#1c192c" />
            </LineChart>
          </ResponsiveContainer>

          {/* PieCharts pro průměrné hodnoty */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: "5px" }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h4>Průměrné Kardio</h4>
              <PieChart width={300} height={100}>
                <Pie data={pieChartDataCardio} dataKey="value" cx="50%" cy="50%" innerRadius={30} outerRadius={50}>
                  {pieChartDataCardio.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.name === 'Kardio' ? '#1c192c' : '#dcdcdc'} />
                  ))}
                </Pie>
              </PieChart>
              <p>{averageCardio.toFixed(1)} / 10</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h4>Průměrná Síla</h4>
              <PieChart width={300} height={100}>
                <Pie data={pieChartDataStrength} dataKey="value" cx="50%" cy="50%" innerRadius={30} outerRadius={50}>
                  {pieChartDataStrength.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.name === 'Síla' ? '#E51937' : '#dcdcdc'} />
                  ))}
                </Pie>
              </PieChart>
              <p>{averageStrength.toFixed(1)} / 10</p>
            </div>

            <div className="start-button-container">
              <button onClick={handleContinue}>Spustit časovač</button>
            </div>
          </div>

<div className="app-version">
  © 2025 Tabataworkout.online. Všechna práva vyhrazena.
  {" | "}
  <a href="/about" style={{ color: "#1c192c" }}>O aplikaci</a>
  {" | "}
  <a href="https://www.tabataworkout.cz" target="_blank" rel="noopener noreferrer" style={{ color: "#1c192c" }}>
    Domů
  </a>
</div>
        </div>
      )}
      
    </div>
  );
};

export default ExerciseSelector;
